import { useImpactPageData } from '#src/app/pages/about/impact/pageContext';

type Result = ModelHookResult<{
	totalVictoryCount: number;
	totalVictoryCountLocalized: string;
}>;

export function useVictoryCount(): Result {
	const {
		data: {
			totalVictoryCount: { count, countLocalized },
		},
	} = useImpactPageData();

	return {
		data: { totalVictoryCount: count, totalVictoryCountLocalized: countLocalized },
	};
}
